import React, { FC, HTMLAttributes } from "react";

type Props = {
  as?: "p" | "span";
} & (HTMLAttributes<HTMLParagraphElement> | HTMLAttributes<HTMLSpanElement>);

const Text: FC<Props> = ({ as, ...props }) => {
  const Component = as || "span";

  return <Component {...props} />;
};

export default Text;
